import { render, staticRenderFns } from "./CustomerTicketTable.vue?vue&type=template&id=aa21a9a8&scoped=true&"
import script from "./CustomerTicketTable.vue?vue&type=script&lang=js&"
export * from "./CustomerTicketTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTicketTable.vue?vue&type=style&index=0&id=aa21a9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa21a9a8",
  null
  
)

export default component.exports